import { useEffect, useState } from 'react'

const INITIAL_STATE = { index: 0, progress: 0, total: 0 }

export function measureStoryScroll(elements, viewportHeight, scrollY) {
  if (!elements.length) return INITIAL_STATE

  const activationOffset = viewportHeight * 0.32
  const anchors = elements.map((element, index) =>
    index === 0 ? 0 : Math.max(0, element.offsetTop - activationOffset),
  )
  let index = 0

  while (index < anchors.length - 1 && scrollY >= anchors[index + 1]) {
    index += 1
  }

  const next = Math.min(index + 1, anchors.length - 1)
  const span = Math.max(1, anchors[next] - anchors[index])
  const progress = next === index ? 0 : (scrollY - anchors[index]) / span
  const lastElement = elements[elements.length - 1]
  const lastScrollPosition = Math.max(
    1,
    lastElement.offsetTop + lastElement.offsetHeight - viewportHeight,
  )

  return {
    index,
    progress: Math.min(1, Math.max(0, progress)),
    total: Math.min(1, Math.max(0, scrollY / lastScrollPosition)),
  }
}

export function useStoryScroll() {
  const [state, setState] = useState(INITIAL_STATE)

  useEffect(() => {
    let frame = 0

    const update = () => {
      frame = 0
      const elements = Array.from(document.querySelectorAll('[data-scene]'))
      setState(measureStoryScroll(elements, window.innerHeight, window.scrollY))
    }

    const schedule = () => {
      if (!frame) frame = window.requestAnimationFrame(update)
    }

    update()
    window.addEventListener('scroll', schedule, { passive: true })
    window.addEventListener('resize', schedule)

    return () => {
      window.removeEventListener('scroll', schedule)
      window.removeEventListener('resize', schedule)
      if (frame) window.cancelAnimationFrame(frame)
    }
  }, [])

  return state
}
